export default {
    loading: {
        module: true
    },
    params: {
        contact_id: null,
        seller_id: null,
        subscriber: [],
        state_auth: [],
        disable:false,
    },
    params_contact:{
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
        seller_id: null
    },
    accounts_from: [],
    contacts:[],
    sellers:[],
    reporte_bo:[],
    stateAuthOption:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-bo/state.js